import { render, staticRenderFns } from "./user-new.vue?vue&type=template&id=7936b012&scoped=true&"
import script from "./user-new.vue?vue&type=script&lang=js&"
export * from "./user-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7936b012",
  null
  
)

export default component.exports